import { render, staticRenderFns } from "./team-extra-data-kv.vue?vue&type=template&id=3a8a504e&"
import script from "./team-extra-data-kv.vue?vue&type=script&lang=js&"
export * from "./team-extra-data-kv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports